import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Text } from '@components/Restyle';
import Icon from '@components/shared/Icon/Icon';

/**
 * Shown when `getPublicTeam` answers "could not be found" for the uuid in the
 * route: the team was deleted, or the link carries a stale (or made-up) uuid.
 *
 * Same layout as `NonMemberContent` — icon, one line, centred in the tab body
 * — minus the action: a not-found team is not a membership verdict, and
 * "Request to Join" there would submit a request against a uuid the backend
 * has already said does not exist (TA-10850 QA).
 */
export const TeamUnavailableContent = () => {
  const { t } = useTranslation('models');

  return (
    <Box flex={1} zIndex={100} justifyContent='center' alignItems='center'>
      <Box alignItems='center' justifyContent='center'>
        <Icon
          variant='xxl'
          color='textPrimary'
          name='AlertTriangle'
          marginRight='s'
        />
        <Text
          variant='heading2'
          color='textSecondary'
          marginTop='s'
          textAlign='center'>
          {t('models:teams.unavailable.title')}
        </Text>
      </Box>
    </Box>
  );
};
